<template>
    <v-container fluid>
      <v-dialog
          v-model="editDialog"
          max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Редактирование данных</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      v-model="editedItem.amount"
                      label="Количество"
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      v-model="editedItem.price"
                      label="Цена"
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      v-model="editedItem.dealerPrice"
                      label="Дилерская цена"
                  ></v-text-field>
                </v-col>
                <v-col cols="12"
                       sm="6"
                       md="4">
                  <v-select :items="selects" label="Для продажи" dense />
                </v-col>
                <v-col cols="12"
                       sm="6"
                       md="4">
                  <v-select :items="selects" label="Скрыть" dense />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="close"
            >
              Отмена
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="save"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card class="mb-4">
        <v-card-title>
          Мои шины
        </v-card-title>
      </v-card>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Фильтр по автомобилю
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="carFilters.brandId" :items="carBrands" label="Марка" item-text="name" item-value="id" @change="fetchModels" outlined dense />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="carFilters.modelId" :items="carModels" label="Модель" item-text="name" item-value="id" @change="fetchYears" :disabled="!carFilters.brandId" outlined dense />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="carFilters.year" :items="carDirectory" label="Год выпуска" item-text="year" item-value="year" @change="fetchType" :disabled="!carFilters.modelId" outlined dense />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="carFilters.modificationId" :items="carModifications" label="Модификация" item-text="modification" item-value="id" @change="fetchMod" :disabled="!carFilters.year" outlined dense />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select v-model="carFilters.specId" :items="carSpecs" label="Размеры" return-object item-value="id" item-text="title" :disabled="!carFilters.modificationId" outlined dense />
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-btn color="primary" @click="enterCarFilters" class="mr-2">Применить</v-btn>
                  <v-btn text @click="resetCarFilters">Сбросить</v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Фильтр по шинам -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              Фильтр по параметрам шин
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row dense>
                <v-col cols="12" sm="4">
                  <v-select v-model="filters.brandId" :items="tireBrands" item-value="id" item-text="name" label="Бренд" outlined dense persistent-hint multiple />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select v-model="filters.season" :items="seasons" item-value="key" item-text="title" label="Сезон" outlined dense persistent-hint multiple />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select v-model="filters.diameter" :items="diameters" label="Диаметр" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select v-model="filters.width" :items="widths" label="Ширина" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select v-model="filters.height" :items="heights" label="Высота" outlined dense />
                </v-col>
                <v-col cols="12" class="d-flex justify-start">
                  <v-btn color="primary" @click="getData" class="mr-2">Применить</v-btn>
                  <v-btn text @click="resetFilters">Сбросить</v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="mt-6">
          <v-data-table
              :headers="headers"
              :items="data"
              :items-per-page="size"
              :server-items-length="totalElements"
              :options.sync="options"
              :multi-sort="false"
              class="elevation-1"
              :footer-props="{
                'items-per-page-text': 'Строк на странице:',
                'items-per-page-options': [5, 10, 20, 50]
              }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-row>
                  <v-col>
                    <v-btn
                        @click="addTire"
                        depressed
                        color="primary"
                    >
                      <v-icon
                          left
                          dark
                      >
                        mdi-plus
                      </v-icon>
                      Добавить шину
                    </v-btn>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                        @input="search"
                        v-model="searchText"
                        label="Поиск"
                        outlined
                        dense
                        hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                  class="mr-2"
                  @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
</template>
<script>
export default {
  name: 'PartnerTire',
  data() {
    return {
      selects: ['Да', 'Нет'],
      editedItem: {
        amount: null,
        price: null,
        dealerPrice: null,
      },
      editDialog: false,
      searchText: '',
      filters: {
        brandId: null,
        diameter: null,
        width: null,
        height: null,
        season: null,
      },
      carFilters: {
        brandId: null,
        modelId: null,
        year: null,
        modificationId: null,
        specId: null,
      },
      seasons: [
        { key: 'ALL', title: 'Всесезонные'},
        { key: 'SUMMER', title: 'Летние'},
        { key: 'WINTER', title: 'Зимние'},
      ],
      diameters: ['13', '14', '15', '16', '17'],
      widths: ['185', '195', '205', '215'],
      heights: ['55', '60', '65', '70'],
      data: [],
      filteredTires: [],
      tireBrands: [],
      carBrands: [],
      carModels: [],
      carDirectory: [],
      carModifications: [],
      carSpecs: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Наименование', value: 'name' },
        { text: 'Альтернативное наи-ие', value: 'secondName' },
        { text: 'Количество', value: 'amount' },
        { text: 'Цена', value: 'price' },
        { text: 'Дилерская цена', value: 'dealerPrice' },
        { text: 'Бренд', value: 'brand' },
        { text: 'Диаметр', value: 'diameter' },
        { text: 'Высота', value: 'height' },
        { text: 'Сезон', value: 'season' },
        { text: 'Ширина', value: 'width' },
        { text: 'Для продажи', value: 'isForSale' },
        { text: 'Скрыто', value: 'isHidden' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {}
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
    this.getTireBrands()
    this.getCarBrands()
  },
  methods: {
    close () {
      this.editDialog = false
      this.editedItem = {
        amount: null,
        price: null,
        dealerPrice: null,
      }
    },
    save () {
      console.log(this.editedItem)
      this.editDialog = false
      this.editedItem = {
        amount: null,
        price: null,
        dealerPrice: null,
      }
    },
    editItem (item) {
      console.log(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true

    },
    addTire () {
      this.$router.push('/partner/tire/add')
    },
    search () {
      this.getData()
    },
    async getData () {
      console.log(this.options)
      const sortBy = this.options.sortBy && this.options.sortBy.length > 0 ? this.options.sortBy[0] : ''
      const ascOrDesc = sortBy ? this.options.sortDesc.length > 0 ? (this.options.sortDesc[0] ? 'desc' : 'asc') : '' : ''
      const data = {
        size: this.options['itemsPerPage'],
        page: this.options['page'] - 1,
        diameter: this.filters.diameter,
        width: this.filters.width,
        height: this.filters.height,
      }
      if (this.filters.brandId) {
        data.brandId = this.filters.brandId.join(',')
      }
      if (this.filters.season) {
        data.season = this.filters.season.join(',')
      }
      if (sortBy) {
        data.orderBy = sortBy
        data.ascOrDesc = ascOrDesc
      }
      if (this.searchText) {
        data.name = this.searchText
      }
      try {
        const resp = await this.$store.dispatch('tire/getPartnerTires', data)
        this.data = resp.list.map((item) => {
          item.secondName = item.sharePart.secondName
          item.name = item.sharePart.name
          item.diameter = item.sharePart.diameter
          item.width = item.sharePart.width
          item.height = item.sharePart.height
          item.season = item.sharePart.season
          item.brand = item.sharePart.brand
          item.isForSale = item.isForSale ? 'Да' : 'Нет'
          item.isHidden = item.isHidden ? 'Да' : 'Нет'
          return item
        })
        this.totalElements = resp.totalElements
      } catch (e) {
        console.log(e)
      }
    },
    async getTireBrands() {
      try {
        this.tireBrands = await this.$store.dispatch('tire/getTireBrands')
        console.log(this.tireBrands)
      } catch (e) {
        console.log(e)
      }
    },
    async getCarBrands() {
      try {
        this.carBrands = await this.$store.dispatch('tire/getCarBrands')
      } catch (e) {
        console.log(e)
      }
    },
    async fetchModels() {
      try {
        this.carModels = await this.$store.dispatch('tire/getCarModels', this.carFilters.brandId)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchYears() {
      try {
        this.carDirectory = await this.$store.dispatch('tire/getCarDirectory', {
          brandId: this.carFilters.brandId,
          modelId: this.carFilters.modelId
        })
      } catch (e) {
        console.log(e)
      }
    },
    async fetchType() {
      try {
        this.carModifications = await this.$store.dispatch('tire/getCarDirectory', {
          brandId: this.carFilters.brandId,
          modelId: this.carFilters.modelId,
          year: this.carFilters.year
        })
      } catch (e) {
        console.log(e)
      }
    },
    async fetchMod() {
      try {
        this.carSpecs = await this.$store.dispatch('tire/getCarSpec', this.carFilters.modificationId)
        console.log('this.carSpecs', this.carSpecs)
        this.carSpecs = this.carSpecs.map((item, index) => {
          item.id = index
          const type = item.specType === 'DEFAULT' ? 'С завода' : 'Альтернативный'
          item.title = item.width + '/' + item.height + ' R' + item.diameter +  ' ' + type
          return item
        })
      } catch (e) {
        console.log(e)
      }
    },
    enterCarFilters() {
      this.filters = {
        brandId: null,
        season: null,
        diameter: this.carFilters.specId.diameter,
        width: this.carFilters.specId.width,
        height: this.carFilters.specId.height
      }
      this.getData()
    },
    resetCarFilters () {
      this.carModels = []
      this.carDirectory = []
      this.carSpecs = []
      this.carModifications = []
      this.carFilters =  {
        brandId: null,
        modelId: null,
        year: null,
        modificationId: null,
        specId: null,
      }
    },
    resetFilters() {
      this.filters = {
        make: null,
        model: null,
        year: null,
        diameter: null,
        width: null,
        height: null,
      }
      this.getData()
    }
  }
}
</script>
<style scoped>

</style>